import { render, staticRenderFns } from "./editConfig.vue?vue&type=template&id=c8960500"
import script from "./editConfig.vue?vue&type=script&lang=js"
export * from "./editConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8960500')) {
      api.createRecord('c8960500', component.options)
    } else {
      api.reload('c8960500', component.options)
    }
    module.hot.accept("./editConfig.vue?vue&type=template&id=c8960500", function () {
      api.rerender('c8960500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/platformCard/editConfig.vue"
export default component.exports